import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Fetch } from '../../utils/Utils.js';

// Defined outside BreedDropdown so it keeps a stable identity across
// re-renders — nested inside the component, it would be redefined on every
// render, and React treats that as a brand-new component type. That forces a
// full unmount/remount of every <option> DOM node (instead of patching them)
// whenever BreedDropdown re-renders for any reason, even one unrelated to
// breed (e.g. a sibling field's state changing) — which silently discards
// whatever breed the user had picked, since the remounted list re-applies
// the placeholder's hardcoded `selected` attribute. See SexDropdown for the
// same pattern done correctly.
const Option = (props) => {
  if (props.selected === props.value) {
    return <option value={props.value} selected="selected">{props.name}</option>
  }
  return <option value={props.value}>{props.name}</option>
}

export const BreedDropdown = (props) => {
  const { t } = useTranslation();
  const [breeds, setBreedData] = useState([]);

  useEffect(() => {
    if (props.breeds != null) {
      setBreedData(props.breeds);
      return;
    }
    Fetch("api/data/breeds", "get", null,
      (data) => {
        setBreedData(data);
      },
      () => {console.log("error loading breeds")}
    );
  }, [props.breeds]);

  return (
    <select name="breed" className="breed-text" onChange={props.onChange}
            style={props.style} value={props.selected}>
      {props.showAll &&
       <option value="">{t("all_breeds")}</option>
      }
      {!props.selected && !props.showAll &&
       <option value="" disabled selected hidden>-- {t("breed")} --</option>
      }
      {breeds.map((breed) => (
        <Option key={breed.name}
          value={breed.name}
          name={breed.name}
          selected={props.selected}
        />
      ))}
    </select>
  );
}

export default BreedDropdown;
